import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent } from "vue";
import DefaultInGameLayout from "@/modules/base/layouts/DefaultInGameLayout.vue";
import { Notification } from "@/modules/notifications/entity";
import NotificationComponent from "@/modules/notifications/components/Notification.vue";
import SimpleActionSheet from "@/modules/vue/components/SimpleActionSheet.vue";
import SimpleActionSheetItem from "@/modules/vue/components/SimpleActionSheetItem.vue";
import QueryPaginator from "@/modules/vue/components/QueryPaginator.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {
    const notifications = ref();
    const query = ref(Notification.createQueryBuilder('notification').orderBy('notification.createdAt', 'DESC').addOrderBy('notification.id', 'DESC'));
    const paginator = ref(null);
    const onUpdate = ({
      items
    }) => notifications.value = items;
    const markAsRead = async notification => {
      notification.read = true;
      await notification.save();
      await paginator.value.refresh();
    };
    const markAllAsRead = async () => {
      await Notification.createQueryBuilder('notification').update().set({
        read: true
      }).execute();
      await paginator.value.refresh();
    };
    const deleteAll = async () => {
      await Notification.createQueryBuilder('notification').delete().execute();
      await paginator.value.refresh();
    };
    return (_ctx, _cache) => {
      const _component_Icon = _resolveComponent("Icon");
      const _component_NButton = _resolveComponent("NButton");
      return _openBlock(), _createBlock(DefaultInGameLayout, {
        back: "",
        "no-content-padding": ""
      }, {
        title: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('notifications')), 1)]),
        actionButton: _withCtx(() => [_createVNode(_component_NButton, {
          text: "",
          onClick: _cache[0] || (_cache[0] = () => _ctx.$refs.simpleActionSheet.show())
        }, {
          default: _withCtx(() => [_createVNode(_component_Icon, {
            icon: _ctx.IconEnum.IosCog
          }, null, 8, ["icon"])]),
          _: 1
        }), _createVNode(SimpleActionSheet, {
          ref: "simpleActionSheet"
        }, {
          actions: _withCtx(() => [_createVNode(SimpleActionSheetItem, {
            color: _ctx.ColorEnum.Red,
            disabled: notifications.value.length === 0,
            "hide-on-click": "",
            onClick: deleteAll
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('delete_all')), 1)]),
            _: 1
          }, 8, ["color", "disabled"]), _createVNode(SimpleActionSheetItem, {
            disabled: notifications.value.length === 0,
            "hide-on-click": "",
            onClick: markAllAsRead
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('mark_all_as_read')), 1)]),
            _: 1
          }, 8, ["disabled"])]),
          _: 1
        }, 512)]),
        default: _withCtx(() => [_createVNode(QueryPaginator, {
          ref_key: "paginator",
          ref: paginator,
          query: query.value,
          class: "mt-2",
          onUpdate: onUpdate
        }, {
          default: _withCtx(({
            items
          }) => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items, notification => {
            return _openBlock(), _createBlock(NotificationComponent, {
              key: notification.id,
              notification: notification,
              class: "border-b last:border-b-0",
              onDelete: $event => markAsRead(notification)
            }, null, 8, ["notification", "onDelete"]);
          }), 128))]),
          _: 1
        }, 8, ["query"])]),
        _: 1
      });
    };
  }
});